import { DEFAULT_RPC_SEEDS, type RpcSeed } from '@gonka-wallet/chain';
import type { ChainNodeSource } from '@gonka-wallet/storage';
import { findPresetNode } from './chainNodes.js';

/**
 * Resolve the list of RPC seeds based on the user's settings.
 *
 * Sources:
 *   'gonka-hub' (default) — DEFAULT_RPC_SEEDS, same-origin /api/chain/* via nginx
 *   'preset'              — single-seed pointing at the picked preset node's URL
 *   'custom'              — single-seed pointing at the user-provided URL
 *
 * If `'preset'` is selected but `presetNodeId` is unknown/null (e.g. stored
 * id references a removed preset, or user picked preset before choosing an
 * entry), fall back to DEFAULT_RPC_SEEDS — same behavior as if the user
 * had never switched away from the default.
 */
export function resolveSeeds(
  source: ChainNodeSource,
  customUrl: string | null,
  presetNodeId: string | null = null,
): readonly RpcSeed[] {
  if (source === 'custom' && customUrl) {
    return [{ url: customUrl, pathPrefix: '', label: 'Custom node' }];
  }
  if (source === 'preset') {
    const preset = findPresetNode(presetNodeId);
    if (preset) {
      return [{ url: preset.url, pathPrefix: '', label: preset.label }];
    }
  }
  return DEFAULT_RPC_SEEDS;
}
